import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import { PageEnums } from '../../../enum/page-enums';
import { interval, merge, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, throttle } from 'rxjs/operators';

@Component({
  selector: 'app-search-items',
  templateUrl: './search-items.component.html',
  styleUrls: ['./search-items.component.scss']
})
export class SearchItemsComponent implements OnInit, OnDestroy {
  // searchParams,
  // allSkills for autocomplete
  // open for section open close
  @Input() searchParams: SearchCondition;
  @Output() searchParamsChange = new EventEmitter<SearchCondition>();
  @Input() allSkills: string[][] = [];
  @Input() page: string;
  @Input() forWorker = true;
  @Input() open = true;
  defaultParams = new SearchCondition({});
  showGrossMargin: boolean;
  showSkillSearch: boolean;
  showTextSearch: boolean;

  paramsChange = new Subject<any>();
  paramsChangeSubscription: Subscription;
  timeInterval = this.paramsChange.pipe(throttle(() => interval(500)));
  valueChange = this.paramsChange.pipe(distinctUntilChanged());
  paramsChange$ = merge(this.timeInterval, this.valueChange).pipe(
    debounceTime(100)
  );

  constructor() {}

  ngOnInit() {
    this.showGrossMargin = ([
      PageEnums.worker_detail,
      PageEnums.project_detail
    ] as string[]).includes(this.page);

    this.showSkillSearch = !([
      PageEnums.auto,
      PageEnums.setting
    ] as string[]).includes(this.page);
    this.showTextSearch = !([
      PageEnums.auto,
      PageEnums.setting
    ] as string[]).includes(this.page);

    this.defaultParams = new SearchCondition({});
    this.paramsChangeSubscription = this.paramsChange$.subscribe(_ => {
      this.searchParamsChange.next(this.searchParams);
    });
  }

  ngOnDestroy() {
    this.paramsChangeSubscription.unsubscribe();
  }

  selectDescirption(descriptions: { worker: string; project: string }): string {
    return this.forWorker ? descriptions.worker : descriptions.project;
  }

  valueChanged(key: string): boolean {
    return this.searchParams[key] !== this.defaultParams[key];
  }

  resetSearchkeyword() {
    this.searchParams.keyword = '';
    this.searchParamsChange.next();
  }
  resetSearchSkillList() {
    this.searchParams.required_skills = '';
    this.searchParamsChange.next();
  }

  newRequest() {
    this.paramsChange.next(JSON.stringify(this.searchParams));
  }
  EnterOnSearchBox(event): void {
    if (event.key === 'Enter' && !event.isComposing) {
      event.preventDefault();
      this.newRequest();
    }
  }
}
